import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Chip,
  Container,
  Paper,
  Button,
  CircularProgress,
  Avatar,
  Badge,
  Divider,
  TextField,
  Backdrop,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import FilterListIcon from "@mui/icons-material/FilterList";
import QuestionService from "../services/questionsService";
import { useDispatch, useSelector } from "react-redux";
import { getMarketPlaces } from "../redux/actions/marketplacesActions";
import { getEcommercePlaces } from "../redux/actions/ecommercePlaceActions";
import {
  AccessTime,
  Check,
  Close,
  FilterList,
  Pending,
  QuestionAnswer,
  Reply,
  Visibility,
} from "@mui/icons-material";
import AnswerQuestion from "./UI/reusable-components/QuestionComponents/AnswerQuestion";

export const Questions = () => {
  const dispatch = useDispatch();
  const [loadingPleaces, setLoadingPleaces] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allPlaces, setAllPlaces] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selectedMarketplace, setSelectedMarketplace] = useState("Tümü");
  const [answerModalOpen, setAnswerModalOpen] = useState(false);
  const [filter, setFilter] = useState({
    ecommercePlaceId: 0,
    marketPlaceId: 0,
  });
  const [detailDialog, setDetailDialog] = useState(false);
  const handleOpenAnswerModal = async (question) => {
    setSelectedQuestion(question);
    setAnswerModalOpen(true);
  };
  const handleCloseAnswerModal = () => setAnswerModalOpen(false);

  const authUserId = useSelector((state) => state?.auth?.user?.id);

  const getQuestion = async () => {
    try {
      setLoading(true);
      var response = await QuestionService.fetchQuestions(
        authUserId,
        filter,
        page
      );

      setQuestions(response?.data?.data);
      setTotalCount(response.data?.recordsTotal);
      setLoading(false);
    } catch (exx) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getQuestion();
  }, [authUserId, filter, page]);

  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        setLoadingPleaces(true);
        const [marketResponse, ecommerceResponse] = await Promise.all([
          dispatch(getMarketPlaces()),
          dispatch(getEcommercePlaces()),
        ]);
        const combinedData = [
          ...marketResponse.data.map((item) => ({
            ...item,
            type: "marketplace",
          })),
          ...ecommerceResponse.data.map((item) => ({
            ...item,
            type: "ecommerce",
          })),
        ];
        setAllPlaces(combinedData);
        setLoadingPleaces(false);
      } catch (err) {
        setLoadingPleaces(false);
      }
    };
    fetchPlatforms();
  }, [dispatch]);
  useEffect(() => {
    const pageSize = 10;
    setTotalPages(Math.ceil(totalCount / pageSize));
  }, [totalCount]);

  const getStatusInfo = (status) => {
    switch (status) {
      case 2:
        return {
          label: "Yanıtlandı",
          color: "success",
          icon: <Check sx={{ fontSize: 16 }} />,
        };
      default:
        return {
          label: "Bekliyor",
          color: "warning",
          icon: <AccessTime sx={{ fontSize: 16 }} />,
        };
    }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={200}
      >
        <CircularProgress />
      </Box>
    );
  }
   
  const handleOpenDetail = (question) => {
    setSelectedQuestion(question);
    setDetailDialog(true);
  };

  const handleCloseDetail = () => {
    setDetailDialog(false);
    setSelectedQuestion(null);
  };

  const getStatusChip = (status) => {
    if (status === 2) {
      return (
        <Chip
          label="Cevaplandı"
          color="success"
          size="small"
          sx={{ fontSize: '0.75rem' }}
        />
      );
    }
    return (
      <Chip
        label="Bekliyor"
        color="warning"
        size="small"
        sx={{ fontSize: '0.75rem' }}
      />
    );
  };
  const handleMarketplaceChange = (event) => {
    const selected = event.target.value;

    setSelectedMarketplace(selected);
    setPage(1);
    setFilter((prevFilter) => ({
      ecommercePlaceId: selected?.type === "ecommerce" ? selected.id : 0,
      marketPlaceId: selected?.type === "marketplace" ? selected.id : 0,
    }));
  };
  return (
    <Box
      sx={{
        width: "100%",
        padding: { xs: 0.5, sm: 1, md: 2 },
        maxWidth: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          padding: { xs: 2, sm: 2.5, md: 3 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: { xs: 2, sm: 3, md: 4 },
          mb: { xs: 2, sm: 2.5, md: 3 },
          ml: { xs: 0, sm: 0.5, md: 1 },
          backgroundColor: "#F7F9FC",
          borderRadius: { xs: 1, sm: 1.5, md: 2 },
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 4,
              height: { xs: 20, sm: 24 },
              backgroundColor: "#1F1B45",
              mr: 1,
            }}
          />
          <Typography
            variant="h6"
            sx={{
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              fontWeight: "bold",
              color: "#333",
              fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
            }}
          >
            Pazaryeri Mesajları
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ marginBottom: { xs: 0.5, sm: 1 } }} />

      {/* Filters */}
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: 1.5, sm: 2.5, md: 3 },
          borderRadius: { xs: 1, sm: 1.5, md: 2 },
          boxShadow: 2,
          marginBottom: { xs: 2, sm: 2.5, md: 3 },
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: { xs: 1, sm: 2 },
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <FormControl fullWidth size="small">
            <InputLabel sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>
              Pazar Yeri Filtresi
            </InputLabel>
            <Select
              value={selectedMarketplace}
              label="Pazar Yeri Filtresi"
              onChange={handleMarketplaceChange}
              startAdornment={
                <FilterList
                  sx={{
                    mr: 1,
                    color: "primary.main",
                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  }}
                />
              }
              sx={{
                "& .MuiSelect-select": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
              }}
            >
              <MenuItem
                value="all"
                sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
              >
                Tüm Pazar Yerleri
              </MenuItem>
              {allPlaces?.map((marketplace) => (
                <MenuItem
                  key={marketplace?.id}
                  value={marketplace}
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      maxWidth: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Typography
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                      }}
                    >
                      {marketplace?.name}
                    </Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      {questions.length === 0 ? (
        <Card
          sx={{
            textAlign: "center",
            py: { xs: 3, sm: 4 },
            px: { xs: 2, sm: 3 },
          }}
        >
          <QuestionAnswer
            sx={{
              fontSize: { xs: 36, sm: 48 },
              color: "text.secondary",
              mb: { xs: 1.5, sm: 2 },
            }}
          />
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
          >
            Mesaj bulunmamaktadır
          </Typography>
        </Card>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1.5, sm: 2 },
            width: "100%",
            boxSizing: "border-box",
          }}
        >
      <TableContainer component={Paper} sx={{ maxHeight: '80vh' }}>
        <Table stickyHeader aria-label="questions table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: 150 }}>Pazaryeri</TableCell>
              <TableCell sx={{ minWidth: 100 }}>Tarih</TableCell>
              <TableCell sx={{ minWidth: 200 }}>Ürün</TableCell>
              <TableCell sx={{ minWidth: 120 }}>Müşteri</TableCell>
              <TableCell sx={{ minWidth: 250 }}>Soru</TableCell>
              <TableCell sx={{ minWidth: 250 }}>Cevap</TableCell>
              <TableCell sx={{ minWidth: 100 }}>Durum</TableCell>
              <TableCell sx={{ minWidth: 120 }}>İşlemler</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {questions.map((question) => (
              <TableRow
                key={question.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>
                  {question.marketPlace != null ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Avatar
                        src={question.marketPlace.iconLink}
                        alt={question.marketPlace.name}
                        sx={{ width: 32, height: 32, flexShrink: 0 }}
                      />
                      <Typography variant="subtitle2" noWrap>
                        {question.marketPlace.name}
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Avatar
                        src={question.ecommercePlace.iconLink}
                        alt={question.ecommercePlace.name}
                        sx={{ width: 32, height: 32, flexShrink: 0 }}
                      />
                      <Typography variant="subtitle2" noWrap>
                        {question.ecommercePlace.name}
                      </Typography>
                    </Box>
                  )}
                </TableCell>
                
                <TableCell>
                  <Typography variant="body2" color="text.secondary">
                    {new Date(question.questionCreatedDate).toLocaleDateString("tr-TR")}
                  </Typography>
                </TableCell>
                
                <TableCell>
                  {question.productName && (
                    <Tooltip title={question.productName} arrow>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: 200,
                          cursor: 'pointer'
                        }}
                      >
                        {question.productName}
                      </Typography>
                    </Tooltip>
                  )}
                </TableCell>
                
                <TableCell>
                  {question.customerName && (
                    <Typography variant="body2" color="text.secondary" noWrap>
                      {question.customerName}
                    </Typography>
                  )}
                </TableCell>
                
                <TableCell>
                  {question.questionText && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: 200,
                          flex: 1
                        }}
                      >
                        {question.questionText}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => handleOpenDetail(question)}
                        sx={{ flexShrink: 0 }}
                      >
                        <Visibility fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </TableCell>
                
                <TableCell>
                  {question.answerText ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: 200,
                          flex: 1
                        }}
                      >
                        {question.answerText}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => handleOpenDetail(question)}
                        sx={{ flexShrink: 0 }}
                      >
                        <Visibility fontSize="small" />
                      </IconButton>
                    </Box>
                  ) : (
                    <Typography variant="body2" color="text.disabled">
                      Henüz cevaplanmamış
                    </Typography>
                  )}
                </TableCell>
                
                <TableCell>
                  {getStatusChip(question.status)}
                </TableCell>
                
                <TableCell>
                  <Button
                    variant="contained"
                    startIcon={<Reply />}
                    disabled={question.status === 2}
                    size="small"
                    onClick={() => handleOpenAnswerModal(question)}
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    Yanıtla
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    <Dialog
        open={detailDialog}
        onClose={handleCloseDetail}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Soru & Cevap Detayları
          <IconButton onClick={handleCloseDetail}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedQuestion && (
            <Box sx={{ space: 2 }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Ürün Bilgileri
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  <strong>Ürün:</strong> {selectedQuestion.productName}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  <strong>Müşteri:</strong> {selectedQuestion.customerName}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  <strong>Tarih:</strong> {new Date(selectedQuestion.questionCreatedDate).toLocaleDateString("tr-TR")}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  <strong>Durum:</strong> {selectedQuestion.status === 2 ? 'Cevaplandı' : 'Bekliyor'}
                </Typography>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Müşteri Sorusu
                </Typography>
                <Paper sx={{ p: 2, bgcolor: 'grey.50' }}>
                  <Typography variant="body1">
                    {selectedQuestion.questionText}
                  </Typography>
                </Paper>
              </Box>

              {selectedQuestion.answerText && (
                <Box>
                  <Typography variant="h6" gutterBottom>
                    Verilen Cevap
                  </Typography>
                  <Paper sx={{ p: 2, bgcolor: 'success.50', border: '1px solid', borderColor: 'success.200' }}>
                    <Typography variant="body1">
                      {selectedQuestion.answerText}
                    </Typography>
                  </Paper>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {selectedQuestion && selectedQuestion.status !== 2 && (
            <Button
              variant="contained"
              startIcon={<Reply />}
              onClick={() => {
                handleCloseDetail();
                handleOpenAnswerModal(selectedQuestion);
              }}
            >
              Yanıtla
            </Button>
          )}
          <Button onClick={handleCloseDetail}>Kapat</Button>
        </DialogActions>
      </Dialog>
        </Box>


      )}

      {/* Pagination */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 1, sm: 2 },
          marginTop: { xs: 1.5, sm: 2 },
          flexWrap: "wrap",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Button
          variant="outlined"
          disabled={page === 1}
          onClick={() => setPage((prev) => prev - 1)}
          size="small"
          sx={{
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
            py: { xs: 0.5, sm: 1 },
            px: { xs: 1, sm: 2 },
            minWidth: { xs: "60px", sm: "80px" },
          }}
        >
          Geri
        </Button>

        <Typography
          variant="body1"
          component="span"
          sx={{
            fontSize: { xs: "0.875rem", sm: "1rem" },
            mx: { xs: 0.5, sm: 1 },
            whiteSpace: "nowrap",
          }}
        >
          Sayfa {page} / {totalPages}
        </Typography>

        <Button
          variant="contained"
          disabled={page >= totalPages}
          onClick={() => setPage((prev) => prev + 1)}
          size="small"
          sx={{
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
            py: { xs: 0.5, sm: 1 },
            px: { xs: 1, sm: 2 },
            minWidth: { xs: "60px", sm: "80px" },
          }}
        >
          İleri
        </Button>
      </Box>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.modal + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
        open={loading}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>

      <AnswerQuestion
        open={answerModalOpen}
        onClose={handleCloseAnswerModal}
        question={selectedQuestion}
      />
    </Box>
  );
};

export default Questions;
